import { baseApi } from '../baseApi';
import {
  CheckoutProducts,
  CheckoutProductsResponse,
  CheckoutSession,
  CheckoutSessionResponse,
  TopUpCheckoutSessionRequestData,
} from './types';

const stripeApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createTopUpCheckoutSession: build.mutation<
      CheckoutSession,
      TopUpCheckoutSessionRequestData
    >({
      query: ({ quantity, priceId, successUrl, cancelUrl }) => {
        const formData = new FormData();

        formData.set('price_id', priceId);

        formData.set('success_url', successUrl);
        formData.set('cancel_url', cancelUrl);

        formData.set('platform', `web_app`);
        formData.set('device_type', `desktop`);

        formData.set('mode', `payment`);
        formData.set('quantity', quantity.toString());

        return {
          url: '/stripe/checkout-session',
          method: 'POST',
          body: formData,
        };
      },
      transformResponse: ({
        checkout_session_url,
      }: CheckoutSessionResponse) => ({
        checkoutSessionUrl: checkout_session_url,
      }),
      invalidatesTags: ['Apps'],
    }),
    getOneTimeProducts: build.query<CheckoutProducts, void>({
      query: () => ({
        url: '/stripe/products/one-time',
      }),
      transformResponse: (products: CheckoutProductsResponse) =>
        products.map(
          ({
            is_virtual: isVirtual,
            is_add_on: isAddOn,
            prices,
            ...product
          }) => ({
            ...product,
            isVirtual,
            isAddOn,
            prices: prices.map(({ unit_amount: unitAmount, ...price }) => ({
              ...price,
              unitAmount,
              priceCents: unitAmount / 100,
            })),
          })
        ),
      providesTags: ['Apps'],
    }),
  }),
});

export default stripeApi;
